import { render, staticRenderFns } from "./CustomCounter.vue?vue&type=template&id=746ac214&scoped=true&"
import script from "./CustomCounter.vue?vue&type=script&lang=js&"
export * from "./CustomCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ac214",
  null
  
)

export default component.exports